export default "__VITE_ASSET__DCj6pWZV__"